import script from "./FithRound.vue?vue&type=script&setup=true&lang=js"
export * from "./FithRound.vue?vue&type=script&setup=true&lang=js"

import "./FithRound.vue?vue&type=style&index=0&id=8796dcc0&lang=css"

const __exports__ = script;

export default __exports__